var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Controller } from 'stimulus';
import { useApplication } from './use-application';
var ApplicationController = /** @class */ (function (_super) {
    __extends(ApplicationController, _super);
    function ApplicationController(context) {
        var _this = _super.call(this, context) || this;
        _this.isPreview = false;
        _this.csrfToken = '';
        useApplication(_this);
        return _this;
    }
    // define function for Typescript but they are overwitten by useApplication
    ApplicationController.prototype.dispatch = function (eventName, eventArgs) { };
    ApplicationController.prototype.metaValue = function (name) {
        return '';
    };
    return ApplicationController;
}(Controller));
export { ApplicationController };
//# sourceMappingURL=application-controller.js.map